<ng-template #modalTmpl>

  <div class="mip-modal-wrapper">

    <nav class="lib-nav">
      <p>Mortgage in Principle</p>
      <span class="lib-spacer"></span>
      <button class="close" (click)="open = false">
        <lib-icon name="close"></lib-icon>
      </button>
    </nav>

    <div class="content">
      <h2>Download your Mortgage&nbsp;in&nbsp;Principle</h2>
      <p class="lib-legend">
        Connect with our mortgage broker partners to get a mortgage in principle.
      </p>

      <div>

        <div class="logo">
          <ngx-picture src="/assets/illustrations/home-me.svg" [lazyLoad]="true"></ngx-picture>
        </div>

        <span class="lib-spacer-fixed"></span>

        <div class="content">
          <p class="lib-legend">Home me are third-party intermediaries, independent and FCA&nbsp;regulated.</p>
          <app-trustbox utmSource="mip" utmMedium="trustpilot"
            [attributes]="{ styleHeight: '24px', styleWidth: '100%', theme: 'light' }"></app-trustbox>
        </div>

      </div>

    </div>

    <form [formGroup]="form" (ngSubmit)="onFormSubmit($event)">

      <div>
        <lib-input placeholder="Phone number" type="text" formControlName="phone" data-test="mip-phone-number">
        </lib-input>
      </div>

      <div>
        <lib-checkbox formControlName="agree_tanc" testAttribute="terms-share-detail-mip">
          I agree to
          <span [hidden]="toggle.signedIn">
            <a href="https://www.proportunity.com/terms-and-conditions" target="_blank">the terms and conditions</a> and
            to&nbsp;
          </span>
          share my details with Home me
        </lib-checkbox>
      </div>

      <div>
        <lib-checkbox formControlName="clean_credit" testAttribute="clean-record-mip">
          I have a clean credit record
        </lib-checkbox>
        <span class="lib-spacer"></span>
        <lib-button (click)="toggle.showDetails = !toggle.showDetails">
          <lib-icon name="chevronUp" [hidden]="!toggle.showDetails"></lib-icon>
          <lib-icon name="chevronDown" [hidden]="toggle.showDetails"></lib-icon>
        </lib-button>
      </div>

      <div class="text-row" [hidden]="!toggle.showDetails">
        <p class="lib-legend">No County Court Judgement (CCJ) registered in the past 6 years (even if satisfied in
          full);</p>
        <p class="lib-legend">No Bankruptcy / IVA / Debt Management Arrangement or Debt Relief Order in last 6 years.
          These can be
          registered against an individual and/or a business if self-employed;</p>
        <p class="lib-legend">No more than 3 missed payments within the past 2 years, and no missed payments within 6
          months prior
          to application;</p>
        <p class="lib-legend">No more than 3 defaults, totalling no more than £500. All defaults must be satisfied 6
          months prior
          to application;</p>
      </div>

      <div>
        <button class="lib-button-flat-link" [disabled]="form.invalid || form.disabled" type="submit"
          data-test="download-mip-modal-button">
          <span class="lib-spacer"></span>
          <lib-icon name="download"></lib-icon>
          <span>Download</span>
          <span class="lib-spacer"></span>
        </button>
      </div>
    </form>

  </div>

</ng-template>